import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import './AdministratorSidebar.css';
import "bootstrap/dist/css/bootstrap.min.css"; // Add Bootstrap for styling

const UserSidebar = () => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null); // Track which submenu is open

  const toggleSidebar = () => {
    setIsSidebarActive(!isSidebarActive);
  };

  // Toggle function for home and pages submenu, with close for the other submenu
  const toggleSubmenu = (submenu) => {
    setOpenSubmenu(openSubmenu === submenu ? null : submenu); // Close if the same submenu is clicked
  };

  return (
    <div className="wrapper">
      {/* Sidebar Holder */}
      <nav id="sidebar" className={isSidebarActive ? 'active' : ''}>
        <div className="sidebar-header">
          <h3>User Panel</h3>
        </div>

        <ul className="list-unstyled components">
          {/* Display user's first and last name */}

          <li>
            <Link to="/admin-panel">Dashboard</Link>
          </li>

          <li className={openSubmenu === 'purchase' ? 'active' : ''}>
            <a
              href="#saleSubmenu"
              onClick={() => toggleSubmenu('purchase')} // Pass submenu identifier
              className="dropdown-toggle"
            >
              Purchase Details
            </a>
            {openSubmenu === 'purchase' && (
              <ul className="list-unstyled">
                <li>
                  <Link to="/purchased-vehicles">Vehicles Details</Link>
                </li>
                <li>
                  <Link to="/view-purchase">View Purchase</Link>
                </li>
                <li>
                  <Link to="/client-accounts">View Accounts</Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link to="/portfolio">Portfolio</Link>
          </li>

        </ul>
      </nav>
      {/* Page Content Holder */}
    </div>
  );
};

export default UserSidebar;
